<template>
  <transition name="fade">
    <div class="forgot-pass-container">
      <div class="forgot-pass-wrapper">
        <div class="forgot-pass-header">
          <div class=" column100 flex-space-between items-center">
            <div class="forgot-pass-header"></div>
            <div
              class="forgot-pass-header__btn-close cursor-pointer"
              @click.prevent="closeModal"
            >
              <i class="fa-solid fa-xmark"></i>
            </div>
          </div>
        </div>
        <div class="text-bold text-18 text-center">Lupa Kata Sandi</div>
        <div class="forgot-pass-content text-14">
          <div class="column100">
            <label for="">Email Terdaftar</label>
            <input
              type="text"
              placeholder="Masukkan Email Terdaftar"
              v-model="email"
            />
          </div>
          <div class="btn-submit-forgot-pass">
            <button class="btn-submit" @click="sendEmail" :disabled="isLoading">
              {{ isLoading ? 'Loading ...' : 'Kirim' }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import axios from 'axios'
import { api } from '../services/config'
export default {
  data() {
    return {
      email: '',
      isLoading: false,
    }
  },
  methods: {
    closeModal() {
      console.log('tutup modal')
      this.$emit('closeForgotPass')
    },
    beforeDestroy() {
      this.email = ''
    },
    async sendEmail() {
      this.isLoading = true
      try {
        if (!this.email && this.email == '') {
          alert('Silahkan isi email anda terlebih dahulu!')
        } else {
          const url = `${api}/api/v1/auth/forget`
          const { data } = await axios({
            method: 'POST',
            url,
            data: {
              email: this.email,
            },
          })

          if (data && data.status == 'success') {
            this.isLoading = false
            alert(
              'Email reset password telah dikirim, silahkan cek email anda.'
            )
            this.beforeDestroy()
            this.closeModal()
          } else {
            throw new Error('Terjadi kesalaha, silahkan ulangi')
          }
        }
      } catch (error) {
        this.isLoading = false
        console.log('error', error)
      }
    },
  },
}
</script>
